module.exports = __webpack_public_path__ + "static/img/2.5cfb664.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/1/sp/2.png
// module id = OUJK
// module chunks = 0